<template>
  <div class="main main--login">

    <div class="container invoice-add">
      <img src="../../../assets/img/logo.png" alt="geberit" class="login__logo" v-if="!user" />
      <p class="invoice-add__login">
        Zarejestruj dowody zakupu w Programie Geberit Pro
      </p>
      <div v-if="contests.length == 0 && contracts == 0" class="danger">
        Obecnie nie ma aktywnych konkursów!
      </div>
      <form v-else class="form" @submit.prevent="add">
        <div class="form__input-container">
          <input type="tel" maxlength="15" v-model="phone" name="phone" class="form__input"
            v-bind:class="{ 'form__input--error': errors.phone }" placeholder="Numer telefonu" required
            :disabled="user" />
          <transition name="fade">
            <p class="form__error" v-if="errors.phone">{{ errors.phone[0] }}</p>
          </transition>
        </div>
        <div class="form__input-container">
          <input type="text" v-model="amount" name="amount" class="form__input"
            v-bind:class="{ 'form__input--error': errors.amount }" placeholder="Kwota netto" required />
          <transition name="fade">
            <p class="form__error" v-if="errors.amount">{{ errors.amount[0] }}</p>
          </transition>
        </div>

        <div v-if="contests.length">
          <div class="form__input-container">
            <p>Rejestracja w:</p>
          </div>
          <div class="form__input-container" v-for="promo in contests" :key="promo.id">
            <input type="checkbox" :id="'promotions_' + promo.id" :value="promo.id" class="form__checkbox"
              v-model="promotions" />
            <label :for="'promotions_' + promo.id">
              <span>{{ promo.name }} - {{ promo.consent }}</span>
            </label>
          </div>
        </div>

        <div v-if="contracts.length">
          <div class="form__input-container">
            <p>
              <span v-if="contests.length">Lub zarejestruj</span><span v-else>Zarejestruj</span> jako spłatę:
            </p>
          </div>
          <div class="form__input-container" v-for="contract in contracts" :key="contract.id">
            <input type="checkbox" :id="'payments_' + contract.id" :value="contract.id" class="form__checkbox"
              v-model="payments" />
            <label :for="'payments_' + contract.id">
              <span>#{{ contract.id }} - {{ contract.title }} (do spłaty:
                {{ (contract.sale_amount - contract.paid) | pointDecimal }}
                PLN)</span>
            </label>
          </div>
        </div>

        <div class="form__input-container">
          <file-upload class="button button--blue form__submit" post-action="/upload/post" :multiple="true" :drop="true"
            :drop-directory="true" v-model="files" @input-filter="inputFilter" ref="upload">
            Dodaj dowód zakupu
          </file-upload>
        </div>
        <div class="form__input-container invoice-add__photo" v-for="file in files">
          <img v-if="file.thumb" :src="file.thumb" class="" />
          <span v-else class="invoice-add__pdf"></span>
          <a class="invoice-add__delete" href="#" @click.prevent="$refs.upload.remove(file)"></a>
        </div>
        <!--
              <div class="form__input-container" v-if="!user">
                  <input type="checkbox" name="showPrizes" id="showPrizes" class="form__checkbox" v-model="showPrizes">
                  <label for="showPrizes">
                      <span>Nie jestem zarejestrowany w programie, ale chcę skorzystać z Promocji Volex</span>
                  </label>
              </div>
              <transition name="fade">
                  <div v-if="showPrizes">
                      <p>Podaj swoje dane kontaktowe</p>
                      <div class="form__input-container">
                          <input type="text" name="name" v-model="name" class="form__input" placeholder="Imię i Nazwisko / Firma" :required="showPrizes ? true : false">
                      </div>
                      <div class="form__input-container">
                          <input type="text" name="voivodeship" v-model="voivodeship" class="form__input" placeholder="Województwo" :required="showPrizes ? true : false">
                      </div>
                      <div class="form__input-container">
                          <input type="text" name="city" v-model="city" class="form__input" placeholder="Miasto" :required="showPrizes ? true : false">
                      </div>
                      <div class="form__input-container">
                          <input type="text" name="postal_code" v-model="postal_code" class="form__input" placeholder="Kod pocztowy" :required="showPrizes ? true : false">
                      </div>
                      <div class="form__input-container">
                          <input type="text" name="address" v-model="address" class="form__input" placeholder="Adres" :required="showPrizes ? true : false">
                      </div>
                      <multiselect
                          v-model="selectedPrizes"
                          :options="prizes"
                          :multiple="true"
                          track-by="id"
                          label="name"
                          :searchable="false"
                          placeholder="Wybierz nagrodę"
                          selectLabel=""
                          deselectLabel=""
                          selectedLabel=""
                          :close-on-select="false"
                          :max-height="500"
                      ></multiselect>

                  </div>
              </transition>
              -->

        <div class="form__input-container">
          <button class="button button--blue form__submit" :disabled="submitted">
            Wyślij &raquo;
          </button>
        </div>
        <div class="form__input-container">
          <!--
                  <p class="invoice-add__login" >
                      <a :href="volex10FileLink" target="_blank" download="regulamin_volex10">Regulamin promocji Volex 10.0</a>
                  </p>
                  -->
          <p class="invoice-add__login">
            <a :href="geberitFileLink" target="_blank" download="regulamin_geberit">Regulamin Geberit Pro</a>
          </p>
        </div>
        <div class="form__input-container">
          <p class="invoice-add__login">
            <a href="https://www.geberit.pl/uslugi/szkolenia/geberit-pro/" target="_blank"
              title="szkolenie geberit pro">Dowiedz się więcej o programie Geberit Pro</a>
          </p>
        </div>
        <div class="form__input-container" v-if="!user">
          <p class="invoice-add__login invoice-add__login--no-margin">
            Masz konto?
            <router-link :to="{ name: 'AuthenticationLogin' }">Zaloguj się</router-link>
          </p>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueUploadComponent from "vue-upload-component";
// import volexFile from "../../../assets/img/volex_8_regulamin_akcji_promocyjnej.pdf"
// import volex10File from "../../../assets/img/volex_10_regulamin_akcji_promocyjnej_z_zalacznikiem.pdf"
import geberitFile from "../../../assets/img/Regulamin_Geberit_Pro_2021.pdf";
import { store } from "@/app/store";
import Multiselect from "vue-multiselect";

export default {
  name: "InvoicesAddComponent",
  data() {
    return {
      contests: [],
      contracts: [],
      amount: null,
      phone: this.$store.state.user ? this.$store.state.user.phone : null,
      promotions: [],
      payments: [],
      files: [],
      errors: [],
      showPrizes: false,
      prizes: [],
      selectedPrizes: [],
      submitted: false,
      comment: "",
      // volexFileLink: volexFile,
      // volex10FileLink: volex10File,
      geberitFileLink: geberitFile,
      name: "",
      voivodeship: "",
      city: "",
      postal_code: "",
      address: "",
    };
  },
  components: {
    FileUpload: VueUploadComponent,
    Multiselect: Multiselect,
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    // activeContests() {
    //     return this.contests.filter(function(c) {
    //         return c.is_active
    //     })
    // }
  },
  mounted: function () {
    if (!this.user || this.user.id != 1) {
      this.$gtag.pageview({
        page_path: "/dodaj-dowod-zakupu",
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    /**
     * Get current user object.
     */
    Vue.axios
      .all([
        Vue.axios({
          method: "get",
          url: "/contests/current",
        }),
        // Vue.axios({
        //   method: "get",
        //   url: "/contracts/current",
        // }),
      ])
      .then(
        Vue.axios.spread((contestsReponse, contractsResponse) => {
          next((vm) => {
            vm.contests = contestsReponse.data.data.contests;
            //vm.contracts = contractsResponse.data.data.contracts
          });
        })
      )
      .catch((error) => next(false));
  },
  methods: {
    add: function () {
      var _this = this;
      _this.submitted = true;
      if (this.files.length == 0) {
        _this.submitted = false;
        return this.$toasted.error("Dodaj dowód zakupu", {
          theme: "toasted-primary",
          position: "top-center",
          duration: 5000,
          fullWidth: true,
          className: "mda-toasted",
          action: {
            text: "Zamknij",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        });
      }

      if (this.promotions.length < 1 && this.payments.length < 1) {
        _this.submitted = false;
        return this.$toasted.error("Wybierz przynajmniej jeden checkbox", {
          theme: "toasted-primary",
          position: "top-center",
          duration: 5000,
          fullWidth: true,
          className: "mda-toasted",
          action: {
            text: "Zamknij",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            },
          },
        });
      }

      var formData = new FormData();

      this.promotions.forEach(function (value, index) {
        formData.append("contests[]", value);
      });
      this.payments.forEach(function (value, index) {
        formData.append("contracts[]", value);
      });

      formData.append("amount", this.amount);
      formData.append("phone", this.phone);
      if (this.comment) formData.append("additional_info", this.comment);

      this.files.forEach(function (value, index) {
        formData.append("photos[]", value.file, value.file.name);
      });

      /* Zakomentowane dnai 01.14.2022 z racji wyłączenie promocji Volex */
      // if( this.showPrizes ) {
      //     formData.append('name', this.name)
      //     formData.append('voivodeship', this.voivodeship)
      //     formData.append('city', this.city)
      //     formData.append('postal_code', this.postal_code)
      //     formData.append('address', this.address)
      // }

      // var prizes = []
      // _this.selectedPrizes.forEach(function(value, index) {
      //     formData.append('prizes['+value.id+'][id]', value.id);
      // });

      Vue.axios({
        method: "post",
        url: "/invoices",
        data: formData,
      })
        .then((response) => {
          _this.submitted = false;
          _this.showPrizes = false;
          _this.amount = null;
          _this.comment = "";
          _this.promotions = [];
          _this.payments = [];
          _this.files = [];
          _this.errors = [];
          // _this.selectedPrizes = []
          this.$toasted.success(response.data.message, {
            theme: "toasted-primary",
            position: "top-center",
            duration: 5000,
            fullWidth: true,
            className: "mda-toasted",
            action: {
              text: "Zamknij",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          });
        })
        .catch((error) => {
          _this.submitted = false;
          _this.errors = error.response.data.errors;
          if (_this.errors) {
            for (var error in _this.errors) {
              this.$toasted.error(_this.errors[error][0], {
                theme: "toasted-primary",
                position: "top-center",
                duration: 5000,
                fullWidth: true,
                className: "mda-toasted",
                action: {
                  text: "Zamknij",
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  },
                },
              });
            }
          }
        });
    },
    /**
     * Has changed
     * @param  Object|undefined   newFile   Read only
     * @param  Object|undefined   oldFile   Read only
     * @return undefined
     */
    inputFile: function (newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        // console.log('response', newFile.response)
        if (newFile.xhr) {
          //  Get the response status code
          //   console.log('status', newFile.xhr.status)
        }
      }
    },
    /**
     * Pretreatment
     * @param  Object|undefined   newFile   Read and write
     * @param  Object|undefined   oldFile   Read only
     * @param  Function           prevent   Prevent changing
     * @return undefined
     */
    inputFilter: function (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }
      }

      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }

        // Thumbnails
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
    },
  },
  watch: {
    promotions: function (val) {
      if (val.length > 0) {
        this.payments = [];
      }
    },
    payments: function (val) {
      if (val.length > 0) {
        this.promotions = [];
      }
      if (val.length > 1) {
        this.payments = [val[1]];
      }
    },
    phone: function (newValue, oldValue) {
      if (/\s/.test(newValue)) {
        this.phone = oldValue;
      }
      if (isNaN(newValue)) {
        this.phone = oldValue;
      }
    },
    amount: function (newValue, oldValue) {
      if (!newValue) {
        return;
      }
      this.amount = newValue.replace(/[^,\d]/, "");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/app/home/invoices/InvoicesAddComponent.vue